import React, { useEffect, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ReactGA from 'react-ga';

import { API_URL, isMMI } from '../../../config'
import { Button } from '../../../components/_shared';
import { SignInForm } from '../../../components/forms';
import WelcomePanel from '../../../components/WelcomePanel';
import { signInInit } from '../../../store/actions/auth';
import {
  makeSelectUser,
  makeSelectAuthProceeding,
} from '../../../store/selectors';
import Logo from '../../../assets/imgs/logo.png';
import { isEnterprise } from '../../../config';
import { ThemeContext } from '../../../providers/ThemeProvider';
import { ROLE } from '../../../constants';

export const Container = styled.div`
  min-height: 700px;
  max-width: 1080px;

  .panel {
    padding-top: 200px;
  }
  .form-panel {
    padding: 200px 100px;
  }

  @media only screen and (max-width: 639px) {
    min-height: 0;
    .form-panel {
      padding: 50px;
    }
  }
`;

const SignIn = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(makeSelectUser());
  const isProceeding = useSelector(makeSelectAuthProceeding());
  const { setTheme, setOrgId } = useContext(ThemeContext);

  useEffect(() => {
    if (user) {
      console.log('user', JSON.stringify(user));
      localStorage.setItem('visited', 'true');

      ReactGA.event({
        category: 'User',
        action: 'Signed in',
        label: user.email,
      });

      const redirect = new URLSearchParams(location.search).get('redirect');
      if (redirect) {
        history.push(redirect);
      } else if (
        isEnterprise &&
        (user.role === ROLE.Manager ||
          user.role === ROLE.Admin ||
          user.role === ROLE.Manager_Student)
      ) {
        history.push('/manage');
      } else if (user.lastActivity) {
        history.push('/membership');
      } else {
        history.push('/');
      }
    }
  }, [user, history]);

  function sso() {
    window.location.href = `${API_URL}/auth/saml/login`; // redirect to IdP
  }

  const handleSubmit = (data) => {
    dispatch(
      signInInit({
        ...data,
        isEnterprise,
        callback: (data) => {
          if (data.org) {
            setOrgId(data.org);
            setTheme(
              data.theme?.primaryColor,
              data.theme?.headerColor,
              data.logo
            );
          }
        },
      })
    );
  };

  return (
    <div className="w-screen h-screen bg-white flex justify-center flex-col">
      <div className="hidden sm:block flex items-center justify-center w-full bg-primary px-12 py-9">
        <img src={Logo} alt="logo_img" />
      </div>
      <Container className="w-full m-auto flex bg-white shadow-xl sm:shadow-none">
        <div className="panel w-1/2 sm:hidden px-16 pt-24 pb-12 bg-primary">
          <WelcomePanel />
        </div>
        <div className="form-panel w-1/2 sm:w-full px-12 pt-24 pb-12">
          <div className="m-auto ">
            <SignInForm busy={isProceeding} onSubmit={handleSubmit} />
          </div>
          {isMMI && (
            <div className="m-auto">
              <Button
                type="misc"
                className={`w-full font-semibold py-2 px-4 border border-solid rounded-lg text-white bg-primary`}
                caption="Continue with SSO"
                onClick={sso}
              />
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default SignIn;
